import React, { useState } from 'react';
import { Button, Card, Col, Form, Row } from '@themesberg/react-bootstrap';
import PageHeader, { AlertMessage } from '../../components/PageHeader';
import { tokensApi } from '../../services/api';

export default function Tokens() {
  const [type, setType] = useState('EMAIL');
  const [value, setValue] = useState('');
  const [token, setToken] = useState('');
  const [detokenized, setDetokenized] = useState('');
  const [lastToken, setLastToken] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleTokenize = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      const { data, status } = await tokensApi.tokenize(type, value);
      setLastToken(data.token);
      setSuccess(status === 201 ? 'Token created' : 'Existing token returned (deduped)');
    } catch (err) {
      setError(err.message);
    }
  };

  const handleDetokenize = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      const { data } = await tokensApi.detokenize(token);
      setDetokenized(data.value);
      setSuccess('Value recovered');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <>
      <PageHeader title="Tokenization" subtitle="Encrypt PII at rest with per-tenant envelope encryption." />

      <AlertMessage variant="danger" message={error} onClose={() => setError('')} />
      <AlertMessage variant="success" message={success} onClose={() => setSuccess('')} />

      <Row>
        <Col lg={6} className="mb-4">
          <Card border="light" className="shadow-sm">
            <Card.Body>
              <h5 className="mb-3">Tokenize</h5>
              <Form onSubmit={handleTokenize}>
                <Form.Group className="mb-3">
                  <Form.Label>Type</Form.Label>
                  <Form.Control value={type} onChange={(e) => setType(e.target.value)} placeholder="EMAIL" />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Value</Form.Label>
                  <Form.Control required value={value} onChange={(e) => setValue(e.target.value)} placeholder="alice@example.com" />
                </Form.Group>
                <Button variant="primary" type="submit">Tokenize</Button>
              </Form>
              {lastToken ? (
                <div className="mt-4">
                  <Form.Label>Last token</Form.Label>
                  <Form.Control readOnly value={lastToken} />
                </div>
              ) : null}
            </Card.Body>
          </Card>
        </Col>
        <Col lg={6} className="mb-4">
          <Card border="light" className="shadow-sm">
            <Card.Body>
              <h5 className="mb-3">Detokenize</h5>
              <Form onSubmit={handleDetokenize}>
                <Form.Group className="mb-3">
                  <Form.Label>Token</Form.Label>
                  <Form.Control required value={token} onChange={(e) => setToken(e.target.value)} placeholder="tok_…" />
                </Form.Group>
                <Button variant="primary" type="submit">Detokenize</Button>
              </Form>
              {detokenized ? (
                <div className="mt-4">
                  <Form.Label>Plaintext</Form.Label>
                  <Form.Control readOnly value={detokenized} />
                </div>
              ) : null}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
}
